/* NPM */
import cx from "classnames";
/* UTILS */
import clearStorageAndCookies from "../../utils/clearStorageAndCookies";
import useAppContext from "../AppContext";
import {
  loginUrl,
  initialPath,
  logout,
  initialPathUni3,
  initialPathUni4
} from "../../utils/profile";
/* COMPONENTS */
import NextButton from "../NextButton";
import { AsHtml } from "../../utils/translate";
/* STYLES */
import styles from "./styles.module.scss";

const SequenceFooter = ({
  nextButtonProps = {},
  hideButton,
  className,
  message,
  children
}) => {
  const { isDisabled, onNext, className: buttonClassName } = nextButtonProps;
  const { authData, setAuthData, setForceValidation, newQuiz } =
    useAppContext();
  const { loggedInAs } = authData || {};

  const handleLogin = e => {
    e.preventDefault();
    if (loggedInAs) {
      clearStorageAndCookies();
      setAuthData({
        ...authData,
        loggedInAs: ""
      });
      let logoutPath = `${window.location.origin}${initialPath}`;
      if (newQuiz.isUni3) {
        logoutPath = `${window.location.origin}${initialPathUni3}`;
      }
      if (newQuiz.isUni4) {
        logoutPath = `${window.location.origin}${initialPathUni4}`;
      }
      logout(logoutPath);
    } else {
      window.sessionStorage.setItem("attemptedLogin", true);
      window.sessionStorage.setItem("checkSequenceMemberData", true);
      window.location.href = loginUrl(window.location.href);
    }
  };

  const handleOnNext = () => {
    if (!isDisabled) {
      onNext();
    } else {
      setForceValidation(true);
    }
  };

  return (
    <div
      className={cx(styles.footer, {
        [className]: className,
        [styles.wrapperWithMessage]: message
      })}
    >
      {message && <AsHtml value={message} className={styles.message} />}
      {children
        ? children
        : !hideButton && (
            <NextButton
              {...nextButtonProps}
              className={cx(styles.nextButton, {
                [styles.disabled]: isDisabled,
                [buttonClassName]: buttonClassName
              })}
              onNext={handleOnNext}
              isDisabled={false}
              size="content"
            />
          )}

      <div className={styles.authSection}>
        <p
          className={cx(styles.authText, {
            [styles.isTest]: window?.ww?.isTest
          })}
        >
          {loggedInAs
            ? `Logged in as ${loggedInAs}`
            : "Already have an account?"}
        </p>
        <a className={styles.authLink} href="#" onClick={handleLogin}>
          {loggedInAs ? "Not you?" : "Log in"}
        </a>
        <label className={styles.hidden} htmlFor="g-recaptcha-response-100000">
          Recaptcha
        </label>
      </div>
    </div>
  );
};

export default SequenceFooter;
